import { useState, useEffect } from 'react'
import {
  readFunctionalStorage,
  writeFunctionalStorage,
} from '@/utils/privacyPreferences'
import { useNetworkEnvironment } from '@/hooks/useNetworkEnvironment'
import { withNetworkStorageKey } from '@/utils/storageKeys'

export function useSidebarState() {
  const { currentEnv } = useNetworkEnvironment()
  const storageKey = withNetworkStorageKey('admin_portal_sidebar_collapsed', currentEnv)
  const [isCollapsed, setIsCollapsed] = useState<boolean>(() => {
    // Read initial state from localStorage, default to expanded (false)
    try {
      const stored = readFunctionalStorage(storageKey)
      return stored ? JSON.parse(stored) : false
    } catch {
      return false
    }
  })

  useEffect(() => {
    try {
      const stored = readFunctionalStorage(storageKey)
      setIsCollapsed(stored ? JSON.parse(stored) : false)
    } catch {
      setIsCollapsed(false)
    }
  }, [storageKey])

  useEffect(() => {
    // Save to localStorage when state changes
    try {
      writeFunctionalStorage(storageKey, JSON.stringify(isCollapsed))
    } catch {
      // Fail silently if localStorage is unavailable
    }
  }, [isCollapsed, storageKey])

  const toggleSidebar = () => {
    setIsCollapsed(prev => !prev)
  }

  return {
    isCollapsed,
    toggleSidebar,
    setIsCollapsed
  }
}
